import {DataToolsApps} from '../shared/DataToolsApps';

export default class DataToolsOption {

  name: DataToolsApps;
  enabledUrl: string;
  enabled: boolean;

  constructor(name: DataToolsApps, enabledUrl: string, enabled: boolean) {
    this.name = name;
    this.enabledUrl = enabledUrl;
    this.enabled = enabled;
  }
}
